import { delegate } from "@otto-ec/global-resources/event";
import { type DataTrackingEventMap, unlockInit } from "@otto-ec/global-resources/tracking";
import type { Feature } from "@otto-ec/tracking-bct";

const addPositionToFeatures = (position: string, features: Feature[] | undefined) => {
	if (!features || !features.length) return;

	features[0]!.position = Number.parseInt(position);
};

const addFeatureOrder = (ev: DataTrackingEventMap["tr-submit-tracking"]) => {
	const target = ev.target as HTMLElement;
	const parent = target.closest("[data-feature-order]") as HTMLElement;

	if (!parent || !parent.dataset.featureOrder) {
		return;
	}

	const featureOrder = parent.dataset.featureOrder;

	if (ev.detail.method === "submitMerge") {
		const features = ev.detail.parameterMap.features;
		addPositionToFeatures(featureOrder, features);
	}
	if (ev.detail.method === "submitMove") {
		const features = ev.detail.parameterMap.action?.features;
		addPositionToFeatures(featureOrder, features);
	}
};

delegate(window.document, "tr-submit-tracking", ".ft9_product-highlight__container", addFeatureOrder);
unlockInit("ft9.daily_deal.lock.token");
